import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useCurrentUser, useLogout } from "utils/hooks";
import { fetchGroupUsersAction } from "store/actions/groups";

const useFetchGroupUsers = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchGroupUsers = async (groupId: string | null) => {
    if (!groupId) {
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
              query {
                getAllGroupUsers(groupId: "${groupId}") {
                  uuid
                  firstName
                  lastName
                  email
                  slug
                  status
                  role
                  invitingTherapist
                  icon
                  color
                  profile {
                    dob
                    gender
                    idNumber
                  }
                }
              }
            `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_group_members",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        dispatch(fetchGroupUsersAction(resData.data.getAllGroupUsers));
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchGroupUsers,
  };
};

export default useFetchGroupUsers;
